
























import { Component, Vue } from 'vue-property-decorator';
import CloseButton from '@/components/ui/CloseButton.vue';
import Languages from '@/components/blocks/header/Languages.vue';

@Component({
  components: {
    CloseButton,
    Languages,
  },
})
export default class SidebarMenu extends Vue {

  private get navigation(): object[] {
    return this.$config.navigation.header;
  }

  private get isOpen(): boolean {
    return this.$store.state.ui.sidebar;
  }

  private closeMenu(): void {
    this.$store.commit('ui/setSidebar', false);
  }
}
